import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { brandingApi } from '../apiExtras';

const BrandingCtx = createContext({ branding: null, refresh: () => {} });

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(null);

  const refresh = useCallback(async () => {
    try { const b = await brandingApi.get(); setBranding(b); }
    catch { setBranding({ name: 'FRAMEBOX', tagline: 'by Nicola Verardo', logo_url: '', show_text: true, watermark: { enabled: true, text: 'FRAMEBOX', opacity: 0.15 } }); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ branding, refresh }), [branding, refresh]);
  return <BrandingCtx.Provider value={value}>{children}</BrandingCtx.Provider>;
};

export const useBranding = () => useContext(BrandingCtx);
